import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorMessage } from "formik";
const FieldErrorMessage = (props) => (_jsx("div", { className: "invalid-feedback form-error-message d-block", children: _jsx(ErrorMessage, { name: props.errorName }) }));
export default FieldErrorMessage;
